import { client } from '@/client';

// 总览数据
export function getOverview(clusterName) {
  return client.get(`/api/metrics/broker/${clusterName}/overview`);
}
// 图表信息
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/broker/${clusterName}/overview`, others);
}

// 获取Broker列表
export function getBrokerList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/broker/${clusterName}/list`, others);
}

/** 单个server图表数据 */
export function getServerChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/broker/${clusterName}`, others);
}

// 获取配置信息
export function getConfigList(params) {
  const { clusterName, brokerHost, ...others } = params;
  return client.get(`/api/metrics/broker/configuration/${clusterName}/${brokerHost}`, others);
}

// 获取Bundle列表
export function getBundleDataList(params) {
  const { clusterName, brokerHost, ...others } = params;
  return client.get(`/api/metrics/broker/bundles/${clusterName}/${brokerHost}`, others);
}

// bundle下topics
export function getTopicDataList(params) {
  const { clusterName, bundleRange, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/${bundleRange}`, others);
}

// 更新Broker配置
export function updateBrokerService(params) {
  return client.put('/api/resource/broker/config/update', params);
}
